import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {StoreModule} from '@ngrx/store';
import {featureKeyResumo} from './feature-resumo.selectors';
import {featureResumoReducer} from './feature-resumo.reducer';


@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    StoreModule.forFeature(featureKeyResumo, featureResumoReducer),
  ],
})
export class FeatureResumoModule {
}
